import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/facebook-marketplace-prohibited-items';

export default function Example() {
  return (
    <>
      <Head>
        <title>Items You Can't Sell on Facebook Marketplace</title>
        <meta
          name='description'
          content='This article will discuss restricted goods and services on Facebook Marketplace and how to appeal if they mistakenly removed your item.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/facebook-marketplace-prohibited-items' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/facebook-marketplace-prohibited-items' />
        <meta property='og:title' content="Items You Can't Sell on Facebook Marketplace" />
        <meta
          property='og:description'
          content='This article will discuss restricted goods and services on Facebook Marketplace and how to appeal if they mistakenly removed your item.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='March 29th, 2022' />
        <meta property='article:modified_time' content='March 29th, 2022' />
        <meta property='article:tag' content='Facebook Marketplace' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
